import { brandColors } from "@/lib/brandColors"
import { classNames } from "@/utils/classNames"
import Skeleton, { SkeletonTheme } from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

export interface AnimatedSkeletonListProps {
  numSkeletons?: number
  height?: number
}

export const AnimatedSkeletonList: React.FC<AnimatedSkeletonListProps> = ({
  numSkeletons = 10,
  height = 30,
}) => {
  return (
    <div>
      {Array.from({ length: numSkeletons }).map((_, index) => (
        <div key={index}>
          <SkeletonTheme
            baseColor={brandColors.grey3}
            highlightColor={brandColors.grey5}
            height={height}
          >
            <Skeleton
              className={classNames(
                `my-3 ${index % 2 === 0 ? "w-full" : "w-4/5"} `,
              )}
            />
          </SkeletonTheme>
        </div>
      ))}
    </div>
  )
}
